module.exports = __webpack_public_path__ + "img/9999.27a4cfdf.jpg";